import { CommonModule } from '@angular/common';
import { Component, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'otw-checkbox-multiselect-form-field',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxMultiselectFormFieldComponent),
      multi: true,
    },
  ],
  imports: [CommonModule],
  templateUrl: './checkbox-multiselect-form-field.component.html',
  styles: ``,
})
export class CheckboxMultiselectFormFieldComponent
  implements ControlValueAccessor
{
  options = input<{ label: string; value: any }[]>([]);
  containerClass = input<string>('');
  itemClass = input<string>('');
  labelClass = input<string>('');

  selectedValues: any[] = [];
  disabled = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  writeValue(value: any): void {
    if (!value) {
      this.selectedValues = [];
      return;
    }

    this.selectedValues = Array.isArray(value) ? [...value] : [value];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  isSelected(value: any): boolean {
    return this.selectedValues.includes(value);
  }

  onCheckboxChange(event: any, value: string): void {
    const isChecked = event.target.checked;

    if (isChecked) {
      this.selectedValues = [...this.selectedValues, value];
    } else {
      this.selectedValues = this.selectedValues.filter((v) => v !== value);
    }

    this.onChange(this.selectedValues);
    this.onTouched();
  }
}
